import PropTypes from "prop-types";

import { popoutContainerCss } from "../../SecondaryActions.style";
import ShareOption from "./ShareOption";
import { shareOptionsConfig } from "./shareOptionsConfig";

const propTypes = {
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  currentLevelId: PropTypes.string,
  isMobile: PropTypes.bool,
  thumbnail: PropTypes.string,
  title: PropTypes.string,
};

const VIEW_PAGE_BASE_URL = "view";

const ShareOptions = ({
  contentId,
  contentType,
  currentLevelId,
  isMobile,
  thumbnail,
  title,
}) => {
  const { protocol, host, pathname, search } = window.location;
  const viewPageShareUrl = `${protocol}//${host}/${VIEW_PAGE_BASE_URL}/${contentId}`;
  const currentPageShareUrl = `${protocol}//${host}${pathname}${search}`;

  const isViewPage = pathname.startsWith(`/${VIEW_PAGE_BASE_URL}/`);

  const socialShareUrl = isViewPage ? viewPageShareUrl : currentPageShareUrl;

  const shareOptions = shareOptionsConfig(
    socialShareUrl,
    title,
    thumbnail,
    contentType,
  );

  const renderPopOutOptions = () =>
    shareOptions.map((option) => {
      const shareTo = option.name.toLowerCase().replace(/\s+/g, "-");

      return (
        <ShareOption
          key={option.name}
          contentType={contentType}
          currentLevelId={currentLevelId}
          option={option}
          dataProps={{ "data-qa-selector": `share-to-${shareTo}` }}
        />
      );
    });

  if (isMobile) return renderPopOutOptions();

  return (
    <ul role="list" css={popoutContainerCss}>
      {renderPopOutOptions()}
    </ul>
  );
};

ShareOptions.propTypes = propTypes;

export default ShareOptions;
